export default "__VITE_ASSET__Do8fiJN7__"